















import Vue, { PropType } from 'vue';
// import { Company } from '@/modules/buyer/company';
import {
  BuyerCompany as Company,
} from 'mostra';

export default Vue.extend({
  name: 'GAccountCompany',

  props: {
    company: {
      type: Object as PropType<Company>,
      required: true,
    },
  },
  methods: {
    submit() {
      this.$emit('submit', this.company);
    },
  },
});
